import styled from 'styled-components';

export default styled.div`
  && {
    margin-top: 30px;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .text {
      margin-bottom: 20px;
    }
    .btn1 {
      background: rgba(235, 164, 80, 1);
      border: 3px solid #ff8a00;
      :hover {
        background-color: white;
        border: 3px solid #ff8a00;
        span {
          color: rgba(235, 164, 80, 1);
        }
      }
    }
  }
`;
